import {TargetingOption} from "./reducer";

export const TransformOptionResponse = (response: OptionResponse): TargetingOption[] => {
    let options: TargetingOption[] = [];

    response.options.forEach((o) => {
        options.push({
            label: o.title, value: o.value
        })
    })

    return options
}

export interface OptionResponse {
    options: OptionResponseOption[];
}

export interface OptionResponseOption {
    value: string | number;
    title: string;
}
